export default __webpack_public_path__ + "static/media/document-text-white.26a0b153.svg";